import { configuratorBuilder } from 'jms-domain'

import { createAdminInterface } from '@salsita-ai/platform-project-sdk/admin'

export const adminInterface = createAdminInterface(configuratorBuilder)
